//! Importing API constants and configurations
import { API_URI } from "../../constants/consts";
import { api } from "../../services/apis/configs/axiosConfigs";

//? Importing necessary types
import type { FeatureResponse } from "./types/types";

export const featureAPI = {

  getAll: async function (
    token: string,
  ): Promise<FeatureResponse> {

    // Define the API URL to fetch features
    const url = `${API_URI}/admin/private/features`;

    try {
      const response = await api.request({
        url: url,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Return the data according to the FeatureResponse structure
      return response.data as FeatureResponse;

    } catch (error) {
      console.error("Error fetching features:", error);
      throw new Error("Failed to fetch features.");
    }
  },
};
